import React from 'react'
import { Box } from 'rebass'
import { colors } from '../theme'
import styled from 'styled-components';

const StyledBox = styled(Box)`
  text-align: center;
`

const Container = (props) => (
  <StyledBox px={[4,5,,5]} py={[5,,,]} {...props}>
    {props.children}
  </StyledBox>
)

export default Container


// WEBPACK FOOTER //
// ./src/elements/Container.js